"use client";

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Avatar as AntdAvatar } from "antd";
import { COLOR_TOKENS, FONT_TOKENS } from "~/designSystem/constants/token";

import { AVATAR_STYLED_PROPS } from "../constants";
import { AvatarStatus } from "../interfaces";

export interface StyledIconAvatarProps {
  $status?: AvatarStatus;
  $stroke?: boolean;
  $size?: number;
  $hoverable?: boolean;
}

export const StyledIconAvatar = styled(AntdAvatar, {
  shouldForwardProp: prop =>
    !AVATAR_STYLED_PROPS.ICON.includes(prop as keyof StyledIconAvatarProps),
})<StyledIconAvatarProps>`
  &.ant-avatar {
    background: ${COLOR_TOKENS.base[3]};
    border: none !important;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 50%;
      ${({ $status }) => css`
        background: ${$status === "active"
          ? COLOR_TOKENS.base[5]
          : $status === "disabled"
            ? COLOR_TOKENS.base[9]
            : "transparent"} !important;
      `}
      ${({ $stroke, $status }) =>
        $stroke &&
        css`
          & {
            border: 1px solid
              ${$status === "disabled"
                ? COLOR_TOKENS.inverted[2]
                : COLOR_TOKENS.inverted[4]} !important;
          }
        `}
    }
    .ant-avatar-string {
      font-size: ${({ $size }) => `${$size ? $size * 0.5 : 10}px`} !important;
      text-transform: uppercase;
      font-weight: ${FONT_TOKENS.weight.semibold};
      color: ${COLOR_TOKENS.white.a12};
    }
  }
  ${({ $hoverable, $status }) =>
    $hoverable &&
    $status !== "disabled" &&
    css`
      &:hover {
        &.ant-avatar::after {
          transition: background 0.1s ease-in-out;
          background: ${COLOR_TOKENS.base[5]} !important;
        }
      }
    `}
`;
